import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import TransactionPage from "./pages/TransactionForm";
import BranchPage from "./pages/BranchPage";
import UserPage from "./pages/UserPage";
import RegisterPage from "./pages/RegisterPage";
import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import { isAuthenticated } from "./utils/auth";

function App() {
  useEffect(() => {
    document.title = process.env.REACT_APP_TITLE || "Laundry Shop";
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/device/register/:id" element={<RegisterPage />} />
        {/* Protected */}
        <Route
          path="/"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header />
                  <DashboardPage />
                </>
              }
            />
          }
        />
        <Route
          path="/add-transaction"
          element={
            <ProtectedRoute
              roles={["user"]}
              element={
                <>
                  <Header />
                  <TransactionPage />
                </>
              }
            />
          }
        />
        <Route
          path="/branches"
          element={
            <ProtectedRoute
              roles={["admin"]}
              element={
                <>
                  <Header />
                  <BranchPage />
                </>
              }
            />
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute
              roles={["admin"]}
              element={
                <>
                  <Header />
                  <UserPage />
                </>
              }
            />
          }
        />
        {/* Redirect all */}
        <Route
          path="*"
          element={<Navigate to={isAuthenticated() ? "/" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
